import Reflux from "reflux";
import * as Immutable from "immutable";
import AuthenticationBackend from "logic/authentication/AuthenticationBackend";
import { qualifyUrl } from "util/URLUtils";
import fetch, { Builder } from "logic/rest/FetchProvider";
import { singletonStore, singletonActions } from "logic/singleton";
import PaginationURL from "util/PaginationURL";
import ApiRoutes from "routing/ApiRoutes";
import UserOverview from "logic/users/UserOverview";
export const AuthenticationActions = singletonActions(
  "Authentication",
  () => Reflux.createActions({
    create: { asyncResult: true },
    delete: { asyncResult: true },
    load: { asyncResult: true },
    loadActive: { asyncResult: true },
    loadBackendsPaginated: { asyncResult: true },
    loadUsersPaginated: { asyncResult: true },
    loadActiveBackendType: { asyncResult: true },
    setActiveBackend: { asyncResult: true },
    testConnection: { asyncResult: true },
    testLogin: { asyncResult: true },
    update: { asyncResult: true }
  })
);
export const AuthenticationStore = singletonStore(
  "Authentication",
  () => Reflux.createStore({
    listenables: [AuthenticationActions],
    getInitialState() {
      return {
        authenticators: null
      };
    },
    create(authBackend) {
      const url = qualifyUrl(ApiRoutes.AuthenticationController.create().url);
      const promise = fetch("POST", url, authBackend).then(
        (result) => result ? {
          backend: AuthenticationBackend.fromJSON(result.backend)
        } : null
      );
      AuthenticationActions.create.promise(promise);
      return promise;
    },
    load(backendId) {
      const url = qualifyUrl(ApiRoutes.AuthenticationController.load(encodeURIComponent(backendId)).url);
      const promise = fetch("GET", url).then(
        (result) => result ? {
          backend: AuthenticationBackend.fromJSON(result.backend)
        } : null
      );
      AuthenticationActions.load.promise(promise);
      return promise;
    },
    loadActive() {
      const url = qualifyUrl(ApiRoutes.AuthenticationController.loadActive().url);
      const promise = fetch("GET", url).then(
        (result) => result ? {
          backend: result.backend ? AuthenticationBackend.fromJSON(result.backend) : null,
          context: { backendsTotal: result.context.backends_total }
        } : null
      );
      AuthenticationActions.loadActive.promise(promise);
      return promise;
    },
    update(backendId, payload) {
      const url = qualifyUrl(ApiRoutes.AuthenticationController.update(backendId).url);
      const promise = fetch("PUT", url, payload).then(
        (result) => result ? {
          backend: AuthenticationBackend.fromJSON(result.backend)
        } : null
      );
      AuthenticationActions.update.promise(promise);
      return promise;
    },
    delete(backendId) {
      const url = qualifyUrl(ApiRoutes.AuthenticationController.delete(backendId).url);
      const promise = fetch("DELETE", url);
      AuthenticationActions.delete.promise(promise);
      return promise;
    },
    testConnection(payload) {
      const url = qualifyUrl(ApiRoutes.AuthenticationController.testConnection().url);
      const promise = fetch("POST", url, payload);
      AuthenticationActions.testConnection.promise(promise);
      return promise;
    },
    testLogin(payload) {
      const url = qualifyUrl(ApiRoutes.AuthenticationController.testLogin().url);
      const promise = fetch("POST", url, payload);
      AuthenticationActions.testLogin.promise(promise);
      return promise;
    },
    setActiveBackend(backendId) {
      const url = qualifyUrl(ApiRoutes.AuthenticationController.updateConfiguration().url);
      const promise = fetch("POST", url, { active_backend: backendId });
      AuthenticationActions.setActiveBackend.promise(promise);
      return promise;
    },
    loadBackendsPaginated({ page, perPage, query }) {
      const url = PaginationURL(ApiRoutes.AuthenticationController.servicesPaginated().url, page, perPage, query);
      const promise = fetch("GET", qualifyUrl(url)).then((response) => ({
        context: {
          activeBackend: response.context.active_backend
        },
        list: Immutable.List(
          response.backends.map((backend) => AuthenticationBackend.fromJSON(backend))
        ),
        pagination: {
          page: response.page,
          perPage: response.per_page,
          query: response.query,
          count: response.count,
          total: response.total
        }
      }));
      AuthenticationActions.loadBackendsPaginated.promise(promise);
      return promise;
    },
    loadUsersPaginated(authBackendId, { page, perPage, query }) {
      const url = PaginationURL(
        ApiRoutes.AuthenticationController.loadUsersPaginated(authBackendId).url,
        page,
        perPage,
        query
      );
      const promise = fetch("GET", qualifyUrl(url)).then((response) => ({
        list: Immutable.List(response.users.map((user) => UserOverview.fromJSON(user))),
        pagination: {
          page: response.page,
          perPage: response.per_page,
          query: response.query,
          count: response.count,
          total: response.total
        },
        adminUser: void 0
      }));
      AuthenticationActions.loadUsersPaginated.promise(promise);
      return promise;
    },
    loadActiveBackendType() {
      const url = qualifyUrl(ApiRoutes.AuthenticationController.loadActiveBackendType().url);
      const promise = new Builder("GET", url).build().then((response) => response.json()).then((result) => result.backend);
      AuthenticationActions.loadActiveBackendType.promise(promise);
      return promise;
    }
  })
);
